var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavigationMap = function SvgNavigationMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.969 2.936-5.28 2.136C3.25 5.224 3 5.591 3 6v14a1 1 0 0 0 1.371.928l4.66-1.864 6 2 5.34-2.136A.999.999 0 0 0 21 18V4a1 1 0 0 0-1.371-.928l-4.66 1.864-6-2ZM10 5.386l4 1.335v11.892l-4-1.334V5.387Zm-2 .09v11.846l-3 1.201V6.678l3-1.201Zm11 0v11.846l-3 1.201V6.678l3-1.201Z"
  })));
};
export default SvgNavigationMap;